import { useState } from "react";
import { ChevronsUpDown, ChevronUp, ChevronDown } from "lucide-react";

// Client-side sorting for dense tables (mirrors the PO table's sort UX).
export function useSort(defaultKey = null, defaultDir = "asc") {
  const [sort, setSort] = useState({ key: defaultKey, dir: defaultDir });
  const toggle = (key) => setSort((s) => (s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" }));
  const apply = (rows, accessors) => {
    if (!sort.key || !accessors[sort.key]) return rows;
    const get = accessors[sort.key];
    return [...rows].sort((a, b) => {
      const x = get(a), y = get(b);
      const c = typeof x === "number" && typeof y === "number" ? x - y : String(x ?? "").localeCompare(String(y ?? ""));
      return sort.dir === "asc" ? c : -c;
    });
  };
  return { sort, toggle, apply };
}

export function SortHeader({ label, k, sort, onSort, align = "left", cls = "" }) {
  const active = sort.key === k;
  const Icon = !active ? ChevronsUpDown : sort.dir === "asc" ? ChevronUp : ChevronDown;
  return (
    <th className={cls}>
      <button type="button" onClick={() => onSort(k)} className={`inline-flex items-center gap-1 hover:text-slate-900 ${align === "right" ? "flex-row-reverse w-full justify-start" : ""}`} data-testid={`sort-${k}`}>
        {label}<Icon className={`h-3 w-3 ${active ? "text-slate-700" : "text-slate-300"}`} />
      </button>
    </th>
  );
}
